import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  updateActualUse,
  getActualUseList,
  updateList,
  id,
  history,
  getSingleActualUse,
  getLandClassificationsList,
  landClassificationsList
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    description: '',
    rptax_land_classification_id: '',
    is_active: ''
  });

  const validateForm = useFormValidator(formData, {
    code: 'required',
    name: 'required',
    description: 'required',
    rptax_land_classification_id: 'required'
  });

  useEffect(() => {
    getLandClassificationsList()
  }, [])

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      name: _.get(formData, 'name').replace(/\s+/g, ' ').trim(),
    };
    updateActualUse(id, args, ({ data }) => {
      setModal({ isOpen: false });
      getActualUseList();
      getSingleActualUse(id);
      history.push(
        `/rpt/land/land-settings/actual-use/${_.get(data, 'id')}`
      );
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,    
        rptax_land_classification_id: `${_.get(updateList, 'rptax_land_classification_id')}`
      };

      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const createDropdownLandClass = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
      });
    });
    return newList;
  };

  const onChangeSelect = e => {
    setFormData({
      ...formData,
      rptax_land_classification_id: e.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Code {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={onChange}
              value={_.get(formData, 'code')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Land Classification {validateForm.renderMessage('rptax_land_classification_id')}
            </label>
            <div>
              <Select
                options={createDropdownLandClass(landClassificationsList)}
                placeholder="Select..."
                value={createDropdownLandClass(landClassificationsList).filter(item => _.get(formData, 'rptax_land_classification_id') === _.get(item, 'value')) || ''}
                onChange={e => {
                  onChangeSelect(e);
                }}
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Active: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active') ? _.get(formData, 'is_active') : ''}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button 
            type="submit" 
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
            disabled={!validateForm.response.is_passed}
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateActualUse: PropTypes.instanceOf(Function).isRequired,
  getActualUseList: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleActualUse: PropTypes.instanceOf(Function).isRequired,
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  landClassificationsList: PropTypes.instanceOf(Object).isRequired
};

const mapStateToProps = ({ api }) => ({
  landClassificationsList: _.get(api, `${c.GET_LAND_CLASSIFICATION_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
